<form-row *ngIf="control">
  <mat-form-field appearance="outline" fxFlex="50">
    <mat-label>Benötigte Leistung{{ requiredMarker ? '*' : '' }}</mat-label>
    <input matInput type="number" [formControl]="control" />
    <span matTextSuffix>{{ powerUnit }}</span>
    <mat-error *ngIf="control.touched && !!control.errors?.min">
      Die Eingabe darf nicht negativ sein
    </mat-error>
    <mat-error *ngIf="control.touched && !!control.errors?.required">
      Bitte geben Sie die benötigte Leistung an
    </mat-error>
    <mat-error *ngIf="control.touched && !!control.errors?.minRequiredPower">
      Die benötigte Leistung muss größer als die installierte Leistung sein
    </mat-error>
  </mat-form-field>
</form-row>
